/**
 * Safe key for RHF paths / GET query object keys derived from question labels.
 * encodeURIComponent alone leaves "." (and "'"), which break RHF nested paths
 * and can corrupt qs GET serialization when decoded too early.
 */
export function encodeTaskFormFilterLabelKey(label: string): string {
  return encodeURIComponent(String(label ?? ''))
    .replace(/\./g, '%2E')
    .replace(/'/g, '%27');
}

export function decodeTaskFormFilterLabelKey(key: string): string {
  try {
    return decodeURIComponent(String(key ?? ''));
  } catch {
    return String(key ?? '');
  }
}

/** Keep encoded keys; drop empty values so GET query stays small and safe. */
export function compactTaskFormFilters(
  filters: Record<string, any> | null | undefined,
): Record<string, any> {
  if (!filters || typeof filters !== 'object') {
    return {};
  }
  return Object.fromEntries(
    Object.entries(filters).filter(([, item]) => {
      const value = item?.value;
      return value !== null && value !== undefined && value !== '';
    }),
  );
}
